import React, { FC, useState, useEffect } from 'react';

import { Grid, Tab } from '@material-ui/core';
import { RouteComponentProps } from '@reach/router';

import { IAdminEvent } from '../../../../store/admin/events/store';
import { ISeason, ISeasonsStore } from '../../../../store/seasons/store';

import Button from '../../../../components/Button';
import { FancyTabs } from '../../../../components/FancyTabs/FancyTabs';
import { navigateTo } from '../../../../contrib/Utils/navigateTo';
import OverviewEvents from '../../Common/OverviewEvents/OverviewEvents';
import { sortSeasonsByYear } from '../../../../Utils/sort';

interface IProps extends RouteComponentProps {
  clubId: number;
  events: IAdminEvent[];
  seasons: ISeasonsStore;
  onSeasonChange: (clubId: number, season: ISeason) => void;
}

const SeasonOverview: FC<IProps> = props => {
  const { onSeasonChange, seasons, clubId, events } = props;

  const seasonList = seasons[clubId] ? sortSeasonsByYear(seasons[clubId].seasons) : [];
  const [activeSeasonIndex, setActiveSeasonIndex] = useState<number>();

  const onTabChange = async (tabIndex: number) => {
    const newSeason = sortSeasonsByYear(seasons[clubId].seasons || [])[tabIndex];

    setActiveSeasonIndex(tabIndex);

    onSeasonChange(clubId, newSeason);
  };

  useEffect(() => {
    const currentClubSeason = seasons[String(clubId)] && seasons[String(clubId)].currentSeason;

    const currentSeasonIndex = seasonList.findIndex(season => season.id === currentClubSeason.id);

    setActiveSeasonIndex(currentSeasonIndex >= 0 ? currentSeasonIndex : 0);
  }, [clubId, seasons, seasonList]);

  const eventsBySeason: { [year: string]: IAdminEvent[] } = events
    .filter(e => !!e.season)
    .reduce(
      (prev: { [year: string]: IAdminEvent[] }, event) => ({
        ...prev,
        [event.season.year]: (prev[event.season.year] || []).concat(event)
      }),
      {}
    );

  return (
    <div className="season-overview">
      <div className="admin-wrapper">
        {seasonList.length > 0 && activeSeasonIndex !== undefined && activeSeasonIndex >= 0 ? (
          <FancyTabs
            outlinedAutoComplete={true}
            useAutoComplete={true}
            currentTab={activeSeasonIndex}
            menuTitle={seasonList[activeSeasonIndex].year}
            extraNavigationElement={
              <Button
                id="create-new-event"
                variant="contained"
                color="primary"
                onClick={navigateTo(`/staff/club/${clubId}/event/new/setup/start`)}
              >
                Create new event
              </Button>
            }
            onChange={onTabChange}
          >
            {seasonList.map(season => (
              <Tab key={season.year} title={season.year}>
                <OverviewEvents events={eventsBySeason[season.year] || []} />
              </Tab>
            ))}
          </FancyTabs>
        ) : (
          <Grid container={true}>
            <Grid item={true} xs={4} />
            <Grid item={true} xs={4}>
              <h4 style={{ textAlign: 'center' }}>
                You need to create a season to be able to create events.
              </h4>

              <Button
                id="create-new-event"
                variant="contained"
                color="primary"
                onClick={navigateTo(`/staff/club/${clubId}/club-settings`)}
              >
                Go to seasons setup
              </Button>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default SeasonOverview;
